// File: src/EnglishTool/nounsPool.js

export function getNounsPool(grade) {
    switch (grade) {
      case 1:
        // Grade 1 nouns
        return [
          { word: "cat", nounType: "common" },
          { word: "dog", nounType: "common" },
          { word: "John", nounType: "proper" },
          { word: "ball", nounType: "common" },
          { word: "mom", nounType: "common" },
          { word: "dad", nounType: "common" },
          { word: "love", nounType: "abstract" },
          { word: "bed", nounType: "concrete" },
          { word: "toy", nounType: "concrete" },
          { word: "apple", nounType: "concrete" },
        ];
  
      case 2:
        // Grade 2 nouns
        return [
          { word: "car", nounType: "concrete" },
          { word: "table", nounType: "concrete" },
          { word: "happiness", nounType: "abstract" },
          { word: "John", nounType: "proper" },
          { word: "child", nounType: "common" },
          { word: "toy", nounType: "common" },
          { word: "apple", nounType: "concrete" },
          { word: "park", nounType: "common" },
          { word: "book", nounType: "concrete" },
          { word: "music", nounType: "abstract" },
        ];
  
      case 3:
        return [
          { word: "computer", nounType: "concrete" },
          { word: "university", nounType: "common" },
          { word: "friendship", nounType: "abstract" },
          { word: "celebration", nounType: "abstract" },
          { word: "camera", nounType: "concrete" },
          { word: "library", nounType: "common" },
          { word: "responsibility", nounType: "abstract" },
          { word: "elephant", nounType: "concrete" },
          { word: "mountain", nounType: "common" },
          { word: "Asia", nounType: "proper" },
        ];
  
      case 4:
        return [
          { word: "committee", nounType: "common" },
          { word: "innovation", nounType: "abstract" },
          { word: "museum", nounType: "common" },
          { word: "class", nounType: "common" },
          { word: "freedom", nounType: "abstract" },
          { word: "equipment", nounType: "concrete" },
          { word: "adventure", nounType: "abstract" },
          { word: "argument", nounType: "abstract" },
          { word: "Paris", nounType: "proper" },
          { word: "Eiffel Tower", nounType: "proper" },
        ];
  
      case 5:
        return [
          { word: "foundation", nounType: "abstract" },
          { word: "curiosity", nounType: "abstract" },
          { word: "tradition", nounType: "abstract" },
          { word: "environment", nounType: "abstract" },
          { word: "humanity", nounType: "abstract" },
          { word: "London", nounType: "proper" },
          { word: "Sunday", nounType: "proper" },
          { word: "furniture", nounType: "concrete" },
          { word: "tranquility", nounType: "abstract" },
          { word: "expression", nounType: "abstract" },
        ];
  
      case 6:
        return [
          { word: "government", nounType: "abstract" },
          { word: "philosophy", nounType: "abstract" },
          { word: "tournament", nounType: "common" },
          { word: "ecosystem", nounType: "common" },
          { word: "volunteer", nounType: "common" },
          { word: "vocabulary", nounType: "abstract" },
          { word: "revolution", nounType: "abstract" },
          { word: "experiment", nounType: "common" },
          { word: "opportunity", nounType: "abstract" },
          { word: "Mount Everest", nounType: "proper" },
        ];
  
        case 7:
            return [
              { word: "controversy", nounType: "abstract" },
              { word: "civilization", nounType: "abstract" },
              { word: "astronomy", nounType: "abstract" },
              { word: "architecture", nounType: "abstract" },
              { word: "conclusion", nounType: "abstract" },
              { word: "community", nounType: "collective" }, // collective
              { word: "regulation", nounType: "abstract" },
              { word: "team's", nounType: "possessive" },     // possessive
              { word: "class's", nounType: "possessive" },    // possessive
              { word: "audience", nounType: "collective" },   // collective
              { word: "Disney", nounType: "proper" },
              { word: "Argentina", nounType: "proper" },
            ];
  
      case 8:
        return [
          { word: "investment", nounType: "abstract" },
          { word: "compassion", nounType: "abstract" },
          { word: "literature", nounType: "abstract" },
          { word: "democracy", nounType: "abstract" },
          { word: "mechanism", nounType: "common" },
          { word: "perspective", nounType: "abstract" },
          { word: "creativity", nounType: "abstract" },
          { word: "reputation", nounType: "abstract" },
          { word: "Africa", nounType: "proper" },
          { word: "Titanic", nounType: "proper" },
        ];
  
      case 9:
        return [
          { word: "explanation", nounType: "abstract" },
          { word: "accomplishment", nounType: "abstract" },
          { word: "phenomenon", nounType: "abstract" },
          { word: "journalism", nounType: "abstract" },
          { word: "collaboration", nounType: "abstract" },
          { word: "profession", nounType: "abstract" },
          { word: "recognition", nounType: "abstract" },
          { word: "hypothesis", nounType: "abstract" },
          { word: "Sahara Desert", nounType: "proper" },
          { word: "Albert Einstein", nounType: "proper" },
        ];
  
      case 10:
        return [
          { word: "interpretation", nounType: "abstract" },
          { word: "negotiation", nounType: "abstract" },
          { word: "significance", nounType: "abstract" },
          { word: "investigation", nounType: "abstract" },
          { word: "generation", nounType: "abstract" },
          { word: "publication", nounType: "common" },
          { word: "transformation", nounType: "abstract" },
          { word: "complexity", nounType: "abstract" },
          { word: "Greece", nounType: "proper" },
          { word: "Middle East", nounType: "proper" },
        ];
  
      case 11:
        return [
          { word: "sustainability", nounType: "abstract" },
          { word: "implication", nounType: "abstract" },
          { word: "constitution", nounType: "common" },
          { word: "infrastructure", nounType: "common" },
          { word: "entrepreneurship", nounType: "abstract" },
          { word: "methodology", nounType: "abstract" },
          { word: "justification", nounType: "abstract" },
          { word: "controversy", nounType: "abstract" },
          { word: "South America", nounType: "proper" },
          { word: "Microsoft", nounType: "proper" },
        ];
  
      case 12:
        return [
          { word: "globalization", nounType: "abstract" },
          { word: "equivalence", nounType: "abstract" },
          { word: "transcendence", nounType: "abstract" },
          { word: "adversity", nounType: "abstract" },
          { word: "intricacy", nounType: "abstract" },
          { word: "jurisprudence", nounType: "abstract" },
          { word: "accountability", nounType: "abstract" },
          { word: "inevitability", nounType: "abstract" },
          { word: "United Nations", nounType: "proper" },
          { word: "Mount Kilimanjaro", nounType: "proper" },
        ];
  
      default:
        // If no grade matched or out of range, return an empty array or a fallback
        return [];
    }
  }
  